<template>
  <div>
    <el-dialog
      v-model="noWrongShow"
      title="Tips"
      width="500"
      :show-close="false"
    >
      <template #header>
        <div class="header">提示</div>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20"><CloseBold /></el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="wrong_text mt-20">
          该阶段暂无错题，是否前往完成经典易错题型
        </div>
        <div class="btn_go cursor_pointer" @click="goClassicsWrongConsolidate">立即前往</div>
        <!-- <div class="text_active">下一阶段</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcH5NoWrong",
  components: {},

  data() {
    return {
      noWrongShow: false,
    };
  },

  mounted() {},

  methods: {
    closePopup() {
      this.noWrongShow = false;
    },
    goClassicsWrongConsolidate(){
      this.$emit('goClassicsWrongConsolidate')
    }
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 373px;
  height: 218px;
  position: relative;
}
:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}
.header {
  //   text-align: center;
  //   font-weight: bold;
  font-size: 20px;
  color: #333333;
  line-height: 60px;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
}
.dialog_content {
  .wrong_text {
    color: #111111;
    text-align: center;
  }
  .btn_go {
    width: 120px;
    height: 42px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    margin: 30px auto 10px;
  }
  .text_active {
    font-size: 14px;
    text-align: center;
  }
}
</style>
